import { render, staticRenderFns } from "./TextColorSelector.vue?vue&type=template&id=02e2b4e4&scoped=true&"
import script from "./TextColorSelector.vue?vue&type=script&lang=js&"
export * from "./TextColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./TextColorSelector.vue?vue&type=style&index=0&id=02e2b4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e2b4e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
